module.exports = "pegasus/assets/lp/product/bg0.png";